export default __webpack_public_path__ + "static/media/view.54c46ef5.png";